import { render } from "./StagePositionDeviceIdentity.vue?vue&type=template&id=0a014f6e&scoped=true"
import script from "./StagePositionDeviceIdentity.vue?vue&type=script&lang=js"
export * from "./StagePositionDeviceIdentity.vue?vue&type=script&lang=js"

import "./StagePositionDeviceIdentity.vue?vue&type=style&index=0&id=0a014f6e&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a014f6e"]])

export default __exports__